// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://arkan-api.premiere-cinemas.com`;
export const SOCKETURL = BASEURL;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://arkan-api.premiere-cinemas.com`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;



// WEBPACK FOOTER //
// ./src/config/index.js